import { supabase } from "../lib/supabase";

export const floorPlanService = {
  // ✅ Upload PDF to Supabase Storage
  async uploadFloorPlanPDF(file) {
    if (!file) throw new Error("No se proporcionó archivo");

    const fileName = `floorplan_${Date.now()}.pdf`;

    // ✅ Upload to bucket
    const { data, error } = await supabase.storage
      .from("floorplans")
      .upload(fileName, file, {
        cacheControl: "3600",
        upsert: false,
      });

    if (error) throw error;

    // ✅ Get Public URL
    const { data: publicUrlData } = supabase.storage
      .from("floorplans")
      .getPublicUrl(fileName);

    return publicUrlData.publicUrl;
  },

  // ✅ Upload Preview Image
  async uploadPreviewImage(blob) {
    const fileName = `preview_${Date.now()}.jpg`;

    const { data, error } = await supabase.storage
      .from("floorplans")
      .upload(fileName, blob, {
        cacheControl: "3600",
        upsert: false,
        contentType: "image/jpeg",
      });

    if (error) throw error;

    const { data: publicUrlData } = supabase.storage
      .from("floorplans")
      .getPublicUrl(fileName);

    return publicUrlData.publicUrl;
  },

  // ✅ Save floor plan record in DB
  async saveFloorPlanToDB({ projectName, sections, lots, pdfUrl, previewUrl }) {
    const { data, error } = await supabase
      .from("floor_plans")
      .insert([
        {
          project_name: projectName,
          sections,
          lots,
          pdf_url: pdfUrl,
          preview_image_url: previewUrl,
          is_active: true,
        },
      ])
      .select()
      .single();

    if (error) throw error;

    return data;
  },
};
